"use client"

import {
  RadarChart as RRadarChart, Radar, PolarGrid, PolarAngleAxis, PolarRadiusAxis,
  Tooltip, Legend, ResponsiveContainer,
} from "recharts"
import {
  type BaseChartProps, DEFAULT_PALETTE, inferSeries, colorFor,
} from "./types"

export interface RadarChartProps extends BaseChartProps {
  /** Render filled radar polygons (vs. outline-only). */
  filled?: boolean
  /** Custom radius-axis domain — e.g. `[0, 100]` for a percentage scale. */
  domain?: [number, number]
}

export function RadarChart({
  data, series, xKey = "name", palette = DEFAULT_PALETTE, colorMap,
  showLegend = true, showTooltip = true,
  className, style, height = "100%", width = "100%",
  filled = true, domain, compact,
}: RadarChartProps) {
  const seriesList = series ?? inferSeries(data, xKey)
  return (
    <ResponsiveContainer width={width} height={height} className={className} style={style}>
      <RRadarChart data={data} margin={{ top: 12, right: 16, left: 16, bottom: 8 }}>
        <PolarGrid />
        <PolarAngleAxis dataKey={xKey} tick={{ fontSize: 10.5, fill: "currentColor" }} />
        <PolarRadiusAxis domain={domain} tick={{ fontSize: 9, fill: "currentColor" }} />
        {showTooltip && <Tooltip cursor={{ fill: "hsl(var(--foreground) / 0.06)", stroke: "hsl(var(--muted-foreground))", strokeOpacity: 0.35 }} contentStyle={{ background: "hsl(var(--card))", border: "1px solid hsl(var(--border))", borderRadius: 6, fontSize: 11, color: "hsl(var(--card-foreground))" }} />}
        {showLegend && !compact && <Legend wrapperStyle={{ fontSize: 11 }} />}
        {seriesList.map((name, i) => {
          const c = colorFor(name, i, palette, colorMap)
          return (
            <Radar key={name} name={name} dataKey={name} stroke={c} fill={c} fillOpacity={filled ? 0.35 : 0} isAnimationActive={false} />
          )
        })}
      </RRadarChart>
    </ResponsiveContainer>
  )
}
